import { useCallback, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Entry, Product } from 'network/response/ICart';
import { updateExtendWarranty } from '../redux/extendWarranty.action';

const useExtendedWarrantyItem = (
  initialSelectedCode: Product['code'],
  {
    productEntryNumber,
    pid,
    quantity,
    isOffer,
    offerId,
  }: {
    productEntryNumber: Entry['entryNumber'];
    pid: Product['code'];
    quantity?: number;
    isOffer?: boolean;
    offerId?: Entry['offerId'];
  }
): any[] => {
  const dispatch = useDispatch();
  const [selectedCode, setSelectedCode] = useState(initialSelectedCode);

  useEffect(() => {
    setSelectedCode(initialSelectedCode);
  }, [initialSelectedCode]);

  const updateExtendWarrantyAction = useCallback(
    (serviceProductCode: Product['code'], oldExtendWarranty: Product['code']) =>
      dispatch(
        updateExtendWarranty({
          warrantyCode: serviceProductCode,
          productCode: pid,
          entryIndex: productEntryNumber,
          oldProductCode: selectedCode,
          qty: quantity,
          isOffer,
          offerId,
          onFailure: () => {
            // reverting to old warranty
            setSelectedCode(oldExtendWarranty);
          },
        })
      ),
    [dispatch, pid, productEntryNumber, selectedCode, quantity, isOffer, offerId]
  );

  const updateExtendWarrantyHandler = (serviceProductCode: any) => {
    updateExtendWarrantyAction(serviceProductCode, selectedCode);
    setSelectedCode(serviceProductCode);
  };

  return [selectedCode, updateExtendWarrantyHandler];
};

export default useExtendedWarrantyItem;
